import IRebalAuthForm from '@frontend/dash3/js/components/integrations/irebal/IRebalAuthForm.vue';

export default {
  data() {
    return {
      in_progress_one: false,
      in_progress_all: false,
    };
  },
  props: {
    modelPortfolioId: String,
  },
  methods: {
    authModalLink: function() {
      let success = null;
      let fail = null;
      const promise = new Promise((res, rej) => {
        success = res;
        fail = rej;
      });
      this.$buefy.modal.open({
        parent: this,
        component: IRebalAuthForm,
        hasModalCard: true,
        customClass: '',
        trapFocus: true,
        canCancel: true,
        onCancel: () => false,
        props: {
          'modelPortfolioId': this.modelPortfolioId,
          'success': success,
          'fail': fail,
        },
      });
      return promise;
    },
    checkAuth: async function() {
      // We could use the expiry time to verify the auth here but for now let's just make a preflight API
      // call always.
      const authed = await this.authStatus();
      if (!authed) {
        const authSuccess = await this.authModalLink();
        console.log(authSuccess);

        if (!authSuccess) {
          return false;
        }
        if (authSuccess) {
          return true;
        }
      }
      if (authed) {
        return true;
      }
    },
    authStatus: async function() {
      const resp = await fetch(
          `/api/v1/integrations/irebal/auth/`,
          {
            method: 'GET',
            headers: {
              'X-CSRFToken': this.$root.$data.csrfToken,
              'Content-Type': 'application/json',
            },
          }).then((response) => {
        if (response.ok) {
          return true;
        }
        throw new Error('Auth required');
      }).catch((error) => {
        return false;
      });

      return resp;
    },
    syncPortfolio: async function() {
      const self = this;

      const canContinue = await this.checkAuth();
      if (!canContinue) {
        return false;
      }

      this.in_progress_one = true;

      await fetch(
          `/api/v1/integrations/models/${this.modelPortfolioId}/`,
          {
            method: 'POST',
            headers: {
              'X-CSRFToken': this.$root.$data.csrfToken,
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            if (response.status == 404) {
              this.$buefy.toast.open({
                duration: 5000,
                message: 'Seems we are unable to find that ModelPortfolio. Please try again or contact support at support@yourstake.org',
                position: 'is-top',
                type: 'is-danger',
              });
              return;
            }
            if (response.status == 401) {
              self.require_auth = true;
              self.in_progress_one = false;
              throw new Error('auth required');
            }

            if (response.ok) {
              return response.json();
            }
          })
          .then((responseData) => {
            const data = responseData;
            if (!data) {
              return false;
            }

            const interval = window.setInterval(async function() {
              const taskResponse = await fetch(`/api/v1/tasks/${data.background_task_id}/`);
              const taskData = await taskResponse.json();


              if (taskData.task.status !== 'pending') {
                if (taskData.task.status === 'failed') {
                  self.in_progress_one = false;
                  const errorMessage = taskData.task.meta.error_message || 'Unknown error.';
                  self.$buefy.toast.open({
                    duration: 5000,
                    message: `There was an error: ${errorMessage} Please try again or contact support at support@yourstake.org`,
                    position: 'is-top',
                    type: 'is-danger',
                  });
                }
                if (taskData.task.status === 'complete') {
                  self.in_progress_one = false;

                  self.$buefy.toast.open({
                    duration: 5000,
                    message: 'Sync completed!',
                    position: 'is-top',
                    type: 'is-success',
                  });
                }
                window.clearInterval(interval);
              }
            }, 1500);
          },
          ).catch((error) => {
            return false;
          });
    },
    syncAllPortfolios: async function() {
      const self = this;

      const canContinue = await this.checkAuth();
      if (!canContinue) {
        return false;
      }

      this.in_progress_all = true;

      await fetch(
          `/api/v1/integrations/models/`,
          {
            method: 'GET',
            headers: {
              'X-CSRFToken': this.$root.$data.csrfToken,
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            if (response.status == 401) {
              self.require_auth = true;
              self.in_progress_all = false;
              throw new Error('require auth');
            }

            if (response.ok) {
              return response.json();
            }
          })
          .then((responseData) => {
            const data = responseData;

            const interval = window.setInterval(async function() {
              const taskData = await fetch(`/api/v1/tasks/${data.background_task_id}/`).then((response) => {
                return response.json();
              });

              if (taskData.task.status !== 'pending') {
                if (taskData.task.status === 'failed') {
                  self.in_progress_all = false;

                  self.$buefy.toast.open({
                    duration: 5000,
                    message: 'Seems there was an issue with the sync. Please try again or contact support at support@yourstake.org',
                    position: 'is-top',
                    type: 'is-danger',
                  });
                }
                if (taskData.task.status === 'complete') {
                  self.in_progress_all = false;
                  self.$buefy.toast.open({
                    duration: 5000,
                    message: 'Sync completed!',
                    position: 'is-top',
                    type: 'is-success',
                  });
                  window.setTimeout(() => {
                    window.location.reload();
                  }, 500);
                }

                window.clearInterval(interval);
              }
            }, 1500);
          }).catch((error) => {
            console.log(error);
          });
    },
  },
};
